import React from 'react';
import PropTypes from 'prop-types';
import { TransactionDetails } from './styled';
import {
  TRANSACTION_DETAILS_GS_QUERY,
  TRANSACTION_DETAILS_WIDGET_SETTINGS,
  TRANSACTION_DETAILS_WIDGET_SETTINGS_PREVENTION,
  SMARTASSESSMENT_TRANSACTION_DETAIL_DOWNLOAD,
  SMARTASSESSMENT_TRANSACTION_DETAIL_PREVENTION_DOWNLOAD
} from './constant';

const FRAML_MODULES = [
  'FRAML_ALERT_TRANSACTION_HISTORY',
  'CM_FRAML_ALERT_TRANSACTION_HISTORY',
  'CM_CASE_FRAML_ALERT_TRANSACTION_HISTORY'
];

const TransactionInformatoinTab = ({
  alertId,
  isSmartAssessment,
  isPrevention,
  module
}) => {
  const isFramlPModule = FRAML_MODULES.includes(module);
  // FIN-11542 drift fix: the Triggered Only toggle must show on the FRAML
  // Transaction tab in BOTH the RI and CM contexts. The module-list check alone
  // misses the RI route (effectiveModule there isn't a FRAML_MODULES value), so
  // gate on isPrevention (true for every FRAML prevention alert, RI + CM) as
  // well — TM transactions (isPrevention falsy, non-FRAML module) stay unchanged.
  const showTriggeredOnly = isPrevention || isFramlPModule;

  return (
    <TransactionDetails
      // FIN-11542 drift fix: show Triggered Only / Duration / Date Range labels
      // on the FRAML Transaction tab to match the mock + the Activity tab
      // (ActivityInformationTab passes showWidgetActionLabels={true}).
      showWidgetActionLabels={true}
      settings={
        isPrevention
          ? TRANSACTION_DETAILS_WIDGET_SETTINGS_PREVENTION
          : TRANSACTION_DETAILS_WIDGET_SETTINGS
      }
      alertId={alertId}
      gsQuery={TRANSACTION_DETAILS_GS_QUERY}
      hasTriggeredOnlySwitch={showTriggeredOnly}
      requireTriggeredOnlyParam={!showTriggeredOnly}
      csvHeaders={
        isPrevention
          ? SMARTASSESSMENT_TRANSACTION_DETAIL_PREVENTION_DOWNLOAD
          : SMARTASSESSMENT_TRANSACTION_DETAIL_DOWNLOAD
      }
      isSmartAssessment={true}
      isPrevention={isPrevention}
      module={module}
    />
  );
};

TransactionInformatoinTab.propTypes = {
  alertId: PropTypes.string.isRequired,
  isSmartAssessment: PropTypes.bool,
  isPrevention: PropTypes.bool,
  module: PropTypes.string
};

export default TransactionInformatoinTab;
